type ConvocationModalState = {
  initialStep: 1 | 2,
};

// O reenvio individual não tem passo 1: abre direto na revisão do e-mail.
export const getConvocationModalState = (isResend: boolean): ConvocationModalState => ({
  initialStep: isResend ? 2 : 1,
});
